import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";

import { getCmsBlocks } from "@store/app/actions";
import { getSupportCategories } from "@store/support/actions";
import { getSubjects, sendIncident } from "@store/contacts/actions";
import Breadcrumbs from "@components/Breadcrumbs";
import SupportLayout from "@containers/Support/Layout";
import Heading from "@components/Heading";
import ContactsSidebar from "@containers/Contacts/Sidebar";
import { setGTMUtmInfo } from "@lib/GTMHelper";
import ErrorPage from "@containers/ErrorPage";
import ContactForm from "@containers/Contacts/Form";

class SupportContactPage extends Component {
  componentDidMount() {
    if (this.props.query) {
      setGTMUtmInfo({ query: this.props.query });
    }
  }

  render() {
    return (
      <>
        <Head>
          <title>{`Contacteaza-ne`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 1,
              level: 99,
              name: `Contact`,
            },
          ]}
        />

        <SupportLayout categories={this.props.supportCategories}>
          <article className="lg:flex pt-6">
            <div className="lg:w-4/6 pb-6 lg:pb-0">
              <Heading
                as="h1"
                display="h1"
                title={`Date si formular de contact`}
                classesProp="mb-3"
              />

              {this.props.formSubjects ? (
                <ContactForm
                  queryParams={this.props.query}
                  onFormSubmit={this.props.sendIncident}
                />
              ) : (
                <ErrorPage>
                  Formularul de contact este indisponibil momentan.
                </ErrorPage>
              )}
            </div>

            <div className="lg:w-2/6 pt-12 lg:pt-0 lg:pl-8">
              <ContactsSidebar cmsBlocks={this.props.cmsBlocks} />
            </div>
          </article>
        </SupportLayout>
      </>
    );
  }
}

SupportContactPage.getInitialProps = async (ctx) => {
  const { reduxStore, query } = ctx;

  // Get data from store
  const { categories } = reduxStore.getState().support;
  const { formSubjects } = reduxStore.getState().contacts;
  const promises = [];

  const pageCmsBlocksNames = [
    "contacts-serviciul-relatii-clienti",
    "contacts-sediul-central",
    "contacts-vanzari-corporate",
  ];

  const cmsBlocksToRetrieve = pageCmsBlocksNames.filter(
    (cmsBlockName) => !reduxStore.getState().app.cmsBlocks[cmsBlockName]
  );

  if (cmsBlocksToRetrieve.length > 0) {
    promises.push(reduxStore.dispatch(getCmsBlocks(cmsBlocksToRetrieve)));
  }

  // Load data if misssing
  !categories && promises.push(reduxStore.dispatch(getSupportCategories()));
  !formSubjects && promises.push(reduxStore.dispatch(getSubjects()));

  await Promise.all(promises);

  if (Object.keys(query).length > 0) {
    return { query };
  }
};

SupportContactPage.pageLayout = "default";

export default connect(
  (state) => ({
    formSubjects: state.contacts.formSubjects,
    cmsBlocks: state.app.cmsBlocks,
    supportCategories: state.support.categories,
  }),
  {
    sendIncident,
  }
)(SupportContactPage);
